import { useEffect } from 'react'
const uniqid = require('uniqid')
// import { v4 as uuidv4 } from 'uuid'

import { editableElement } from '~components/Edition/Editables/EditableElement/EditableElement'
import { editableImage } from '~components/Edition/Editables/EditableImage/EditableImage'
// import { editableText } from '~components/Edition/Editables/EditableText/EditableText'

import { useGlobalContext } from '~contexts/globalContext'
import { generateNewPage } from '~hooks/useWebsite'
// import ArticleSectionDefaultData from '~sections/ArticleSection/ArticleSection.defaultData'
// import { articleSectionName } from '~sections/ArticleSection/ArticleSection.definition'
// import BoutiqueSectionDefaultData from '~sections/BoutiqueSection/BoutiqueSection.defaultData'
// import { boutiqueSectionName } from '~sections/BoutiqueSection/BoutiqueSection.definition'
// import ContactSectionDefaultData from '~sections/ContactSection/ContactSection.defaultData'
// import { contactSectionName } from '~sections/ContactSection/ContactSection.definition'
// import HeaderSectionDefaultData from '~sections/HeaderSection/HeaderSection.defaultData'
// import { headerSectionName } from '~sections/HeaderSection/HeaderSection.definition'
import { getPictureURL } from '~utils/cloudinary'
// import LastArticlesSectionDefaultData from '~sections/LastArticlesSection/LastArticlesSection.defaultData'
// import { lastArticlesSectionName } from '~sections/LastArticlesSection/LastArticlesSection.definition'

import { getActivityBoutiqueItems } from '~queries/boutique.queries'
// import { mentionsData } from './mentions.data'
// import { cguvData } from './cguv.data'

export const useOnboarding = () => {
	const { website } = useGlobalContext()

	const generateDefaultPages = async () => {

		await website.refreshData()

		const marketItems = await getActivityBoutiqueItems(website.activities[0].id)

		const hasProduct =
			marketItems.find(({ type }) => type === 'product') !== undefined
		const hasService =
			marketItems.find(({ type }) => type === 'service') !== undefined

		const {
			sectionThemes,
			customColors,
			darkTheme,
			whiteTheme,
			// lightTheme
		} = generateTheme()

		const topbarMenu = []

		let servicePageId = null

		if (hasService && !website.getPageFromSlug('reserver')) {
			const { id: pageId } = await website.addPage(
				generatePage({
					slug: 'reserver',
					sections: [
						// {
						// 	id: uuidv4(),
						// 	type: boutiqueSectionName,
						// 	...BoutiqueSectionDefaultData,
						// 	params: {
						// 		...BoutiqueSectionDefaultData.params,
						// 		type: 'service'
						// 	}
						// }
					]
				})
			)
			servicePageId = pageId
			topbarMenu.push({
				id: uniqid(),
				label: 'Réserver',
				pageId,
				url: '/reserver',
				type: 'internalLink',
				targetBlank: false
			})
		}

		let boutiquePageId = null

		if (hasProduct && !website.getPageFromSlug('boutique')) {
			const { id: pageId } = await website.addPage(
				generatePage({
					slug: 'boutique',
					sections: [
						// {
						// 	id: uuidv4(),
						// 	type: boutiqueSectionName,
						// 	...BoutiqueSectionDefaultData,
						// 	params: {
						// 		...BoutiqueSectionDefaultData.params,
						// 		type: 'product'
						// 	}
						// }
					]
				})
			)
			boutiquePageId = pageId
			topbarMenu.push({
				id: uniqid(),
				label: 'Boutique',
				pageId,
				url: '/boutique',
				type: 'internalLink',
				targetBlank: false
			})
		}

		// const splittedDescription = website.activities?.[0]?.description
		// 	.replace(/\r/g, '')
		// 	.split('\n\n')

		let aProposPageId = null

		if (!website.getPageFromSlug('a-propos')) {
			const { id: pageId } = await website.addPage(
				generatePage({
					slug: 'a-propos',
					sections: [
						// {
						// 	id: uuidv4(),
						// 	type: articleSectionName,
						// 	...ArticleSectionDefaultData,
						// 	data: {
						// 		...ArticleSectionDefaultData.data,
						// 		blocks: [
						// 			{
						// 				id: uniqid(),
						// 				editable: editableImage(
						// 					getPictureURL(website.activities[0].miniature)
						// 				)
						// 			},
						// 			{
						// 				id: uniqid(),
						// 				editable: editableElement(
						// 					website.activities?.[0]?.title,
						// 					'h1'
						// 				)
						// 			},
						// 			...splittedDescription.map((paragraph) => ({
						// 				id: uniqid(),
						// 				editable: editableText(paragraph)
						// 			}))
						// 		]
						// 	}
						// }
					]
				})
			)

			aProposPageId = pageId

			topbarMenu.push({
				id: uniqid(),
				label: 'À Propos',
				pageId,
				url: '/a-propos',
				type: 'internalLink',
				targetBlank: false
			})
		}

		if (!website.getPageFromSlug('')) {
			const findAproposImageURL = () => {
				const activityImage = website.activities.find(
					(activity) => !!activity.miniature?.public_id
				)

				if (activityImage) {
					return getPictureURL(activityImage.miniature)
				}

				return getPictureURL({
					public_id: '/media/lawrence-kayku-ZVKr8wADhpc-unsplash_ovkjk8.jpg'
				})
			}

			const headerSectionSections = [
				{
					title: editableElement('À propos'),
					image: {
						...editableImage(findAproposImageURL()),
						params: {
							alt: '',
							actionType: 'internal-link',
							link: null,
							pageLinkId: aProposPageId
						}
					},
					link: '/a-propos'
				}
			]

			if (hasProduct) {
				const randomProduct = marketItems.find(
					({ type, miniature }) => type === 'product' && miniature?.public_id
				)
				headerSectionSections.unshift({
					title: editableElement('Découvrez la boutique'),
					image: {
						...editableImage(getPictureURL(randomProduct.miniature)),
						params: {
							alt: '',
							actionType: 'internal-link',
							link: null,
							pageLinkId: boutiquePageId
						}
					},
					link: '/boutique'
				})
			}
			if (hasService) {
				const randomService = marketItems.find(
					({ type, miniature }) => type === 'service' && miniature?.public_id
				)
				headerSectionSections.unshift({
					title: editableElement('Réserver'),
					image: {
						...editableImage(getPictureURL(randomService.miniature)),
						params: {
							alt: '',
							actionType: 'internal-link',
							link: null,
							pageLinkId: servicePageId
						}
					},
					link: '/reserver'
				})
			}
			await website.addPage(
				generatePage({
					slug: '',
					sections: [
						// {
						// 	id: uuidv4(),
						// 	type: headerSectionName,
						// 	...HeaderSectionDefaultData,
						// 	data: {
						// 		...HeaderSectionDefaultData.data,
						// 		title: editableElement(website.name),
						// 		sections: headerSectionSections.slice(0, 2)
						// 	},
						// 	params: {
						// 		...HeaderSectionDefaultData.params,
						// 		theme: whiteTheme.id
						// 	}
						// },
						// {
						// 	id: uuidv4(),
						// 	type: lastArticlesSectionName,
						// 	...LastArticlesSectionDefaultData,
						// 	params: {
						// 		...LastArticlesSectionDefaultData.params,
						// 		theme: lightTheme.id
						// 	},
						// 	data: {
						// 		...LastArticlesSectionDefaultData.data,
						// 		button: {
						// 			params: {
						// 				actionType: 'internal-link',
						// 				visible: true,
						// 				pageLinkId: hasProduct ? boutiquePageId : servicePageId
						// 			},
						// 			text: 'Voir tout',
						// 			__element: 'editable-button'
						// 		}
						// 	}
						// },

						// {
						// 	id: uuidv4(),
						// 	type: contactSectionName,
						// 	...ContactSectionDefaultData,
						// 	params: {
						// 		...ContactSectionDefaultData.params,
						// 		display: 'aside',
						// 		theme: whiteTheme.id
						// 	}
						// }
					]
				})
			)
		}

		if (!website.getPageFromSlug('contact')) {
			const { id: pageId } = await website.addPage(
				generatePage({
					slug: 'contact',
					sections: [
						// {
						// 	id: uuidv4(),
						// 	type: contactSectionName,
						// 	...ContactSectionDefaultData,
						// 	params: {
						// 		...ContactSectionDefaultData.params,
						// 		display: 'above'
						// 	}
						// }
					]
				})
			)

			topbarMenu.push({
				id: uniqid(),
				label: 'Contact',
				pageId,
				url: '/contact',
				type: 'internalLink',
				targetBlank: false
			})
		}

		const footerMenuItems = []
		if (!website.getPageFromSlug('mentions')) {
			const { id: pageId } = await website.addPage(
				generatePage({
					slug: 'mentions',
					enabled: false,
					sections: [
						// {
						// 	id: uuidv4(),
						// 	type: articleSectionName,
						// 	...ArticleSectionDefaultData,
						// 	data: mentionsData
						// }
					]
				})
			)

			footerMenuItems.push({
				id: uniqid(),
				label: 'Mentions légales',
				pageId,
				type: 'internalLink',
				url: ''
			})
		}

		if (!website.getPageFromSlug('cguv')) {
			const { id: pageId } = await website.addPage(
				generatePage({
					slug: 'cguv',
					enabled: false,
					sections: [
						// {
						// 	id: uuidv4(),
						// 	type: articleSectionName,
						// 	...ArticleSectionDefaultData,
						// 	data: cguvData
						// }
					]
				})
			)

			footerMenuItems.push({
				id: uniqid(),
				label: 'CGUV',
				pageId,
				type: 'internalLink',
				url: ''
			})
		}

		await website.update({
			theme: {
				...website.theme,
				colors: {
					...website.theme.colors,
					customs: customColors
				},
				sectionThemes,
				topbar: {
					...website.theme.topbar,
					textColor: '#172b49',
					backgroundColor: '#ffffff',
					menu: topbarMenu,
					display: whiteTheme.id
				},
				footer: {
					...website.theme.footer,
					showNewsLetter: true,
					copyright: website.name,
					display: darkTheme.id,
					footerTheme: darkTheme.id,
					nav: [
						{
							label: 'Divers',
							items: footerMenuItems
						}
					]
				},
				logo: {
					...website.theme.logo,
					text: website.name
				},
				typo: {
					...website.theme?.typo,
					h1: {
						fontSize: 40,
						fontFamily: "'Gentium Book Basic', serif",
						fontWeight: 700
					},
					h2: {
						fontSize: 32,
						fontFamily: "'Gentium Book Basic', serif",
						fontWeight: 700
					},
					h3: {
						fontSize: 24,
						fontFamily: "'Gentium Book Basic', serif",
						fontWeight: 700
					},
					p: {
						fontSize: 15,
						fontFamily: "'Montserrat', sans-serif",
						fontWeight: 400
					}
				}
			}
		})

		setTimeout(() => {
			website.update({
				onboarding: false
			})
		}, 3000)
	}

	useEffect(() => {
		generateDefaultPages()
	}, [])
}

const generatePage = ({ slug, sections = [], enabled = true }) => ({
	...generateNewPage(),
	slug,
	sections,
	enabled
})

const generateTheme = () => {
	const darkColor = {
		id: 'kmjqqfqu',
		name: null,
		hex: '#172B49'
	}

	const lightColor = {
		id: 'kmjqrb7w',
		name: null,
		hex: '#f4f5fd'
	}

	const whiteColor = {
		id: 'kmkcztv7',
		name: null,
		hex: '#ffffff'
	}

	const blueColor = {
		id: 'kmm9rdka',
		name: null,
		hex: '#66a3ff'
	}

	const yellowColor = {
		id: 'kmt15urk',
		name: null,
		hex: '#FFEDBD'
	}

	const customColors = [
		blueColor,
		darkColor,
		lightColor,
		whiteColor,
		yellowColor
	]

	const whiteTheme = {
		background: whiteColor.id,
		text: darkColor.id,
		color: null,
		id: 'kmmb0nhp',
		title: darkColor.id,
		name: 'Thème 4',
		button: {
			background: blueColor.id,
			color: whiteColor.id
		}
	}

	const colorfulTheme = {
		background: blueColor.id,
		text: whiteColor.id,
		color: null,
		id: 'kmjq6x87',
		title: whiteColor.id,
		name: 'Thème 2',
		button: {
			background: lightColor.id,
			color: darkColor.id
		}
	}

	const lightTheme = {
		background: lightColor.id,
		text: darkColor.id,
		color: null,
		id: 'kmmaz7jn',
		title: darkColor.id,
		name: 'Thème 3',
		button: {
			background: blueColor.id,
			color: whiteColor.id
		}
	}

	const darkTheme = {
		background: darkColor.id,
		text: whiteColor.id,
		color: null,
		id: 'kmjq7a8u',
		title: whiteColor.id,
		name: 'Thème 1',
		button: {
			background: lightColor.id,
			color: darkColor.id
		}
	}

	const sectionThemes = [whiteTheme, colorfulTheme, lightTheme, darkTheme]

	return {
		sectionThemes,
		customColors,
		darkTheme,
		whiteTheme,
		lightTheme,
		colorfulTheme,
		darkColor,
		lightColor,
		whiteColor
	}
}
